import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import type { RecruitmentShowBottomItemTagsProps as Props } from './types';
import type { OccupationDetailItem, OccupationItem, OtherOccupationItem } from '../../../types/recruitmentShow';
import { showRecruitmentPageOccupations, showRecruitmentPageOthers } from '../../../services/recruitments';

export const Component: FunctionComponent<Props> = (props) => {
  const [occupations, setOccupations] = useState<OccupationItem[]>([])
  const [occupationDetails, setOccupationDetails] = useState<OccupationDetailItem[]>([])
  const [prefecture, setPrefecture] = useState('')
  const [prefectureUrl, setPrefectureUrl] = useState('')
  const [city, setCity] = useState('')
  const [cityId, setCityId] = useState<number | null>(null)
  const [otherOccupations, setOtherOccupations] = useState<OtherOccupationItem[]>([])
  const [multiple, setMultiple] = useState(false)

  useEffect(() => {
    fetchRecruitmentPageOccupations();
    fetchRecruitmentPageOthers();
  }, [props.recruitmentId]);

  const fetchRecruitmentPageOccupations = async () => {
    try {
      const response = await showRecruitmentPageOccupations(props.recruitmentId);
      setOccupations(response.occupations);
      setOccupationDetails(response.occupationDetails);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRecruitmentPageOthers = async () => {
    try {
      const response = await showRecruitmentPageOthers(props.recruitmentId);
      setPrefecture(response.prefecture);
      setPrefectureUrl(response.prefectureUrl);
      setCity(response.city);
      setCityId(response.cityId);
      setOtherOccupations(response.otherOccupations);
      setMultiple(response.multiple);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Presentation
      {...props}
      occupations={occupations}
      occupationDetails={occupationDetails}
      prefecture={prefecture}
      prefectureUrl={prefectureUrl}
      city={city}
      cityId={cityId}
      otherOccupations={otherOccupations}
      multiple={multiple}
    />
  );
};
